import { Card } from '@music-vine/cadence/ui';
import { Text } from '@music-vine/cadence/ui';
import { usePricingOptions } from '@/hooks/api/usePricingOptions';
import { useSubscriptionType } from '@/hooks/auth';
import { useCurrency } from '@/hooks/billing/useCurrency';
import { ProrationBillingMode } from '@/hooks/billing/useProration';
import StyledPrice from '@/components/Modals/SwitchToYearly/components/StyledPrice';
import type { PricingByCurrency } from '@/hooks/api/usePricingOptions';
const MINOR_UNITS_MULTIPLIER = 100;
const CurrentPlanCard = ({
  billingMode
}: {
  billingMode: ProrationBillingMode;
}) => {
  const currency = useCurrency();
  const currentPlan = useSubscriptionType();
  const {
    data: pricingOptions
  } = usePricingOptions();
  const currentPlanData = pricingOptions?.find(plan => plan.title === currentPlan);
  const currencyCode = currency?.code ?? 'GBP';
  const currencyCodeLower = currencyCode.toLowerCase() as keyof PricingByCurrency;
  const valueInMinorUnits = billingMode === ProrationBillingMode.MONTHLY ? Number(currentPlanData?.pricing[currencyCodeLower].monthly) * MINOR_UNITS_MULTIPLIER : Number(currentPlanData?.pricing[currencyCodeLower].yearly) * MINOR_UNITS_MULTIPLIER;
  const frequencyLabel = billingMode === ProrationBillingMode.MONTHLY ? '/month' : '/year';
  return <Card className="flex justify-between gap-2 rounded-2xl border-gray-100 bg-gray-50 px-5 py-4 shadow-none dark:border-gray-800 dark:bg-gray-850" data-sentry-element="Card" data-sentry-component="CurrentPlanCard" data-sentry-source-file="CurrentPlanCard.tsx">
      <div className="space-y-1">
        <Text asChild className="font-sans font-semibold text-base text-gray-950 dark:text-white" data-sentry-element="Text" data-sentry-source-file="CurrentPlanCard.tsx">
          <h3>Uppbeat {currentPlan}</h3>
        </Text>
        <Text className="text-xs" data-sentry-element="Text" data-sentry-source-file="CurrentPlanCard.tsx">Current plan</Text>
      </div>
      <div>
        <StyledPrice classNames={{
        symbol: 'text-xs text-gray-700 dark:text-gray-300',
        integer: 'text-base font-sans font-semibold text-gray-950 dark:text-white',
        decimal: 'text-base font-sans font-semibold text-gray-950 dark:text-white'
      }} currency={currencyCode} valueInMinorUnits={valueInMinorUnits} data-sentry-element="StyledPrice" data-sentry-source-file="CurrentPlanCard.tsx" />
        <span className="text-gray-700 text-xs dark:text-gray-300">
          {frequencyLabel}
        </span>
      </div>
    </Card>;
};
export default CurrentPlanCard;